import { PHONE_GATE_CUTOFF } from '../config';

// Condición PURA del gate de verificación de celular (anti-abuso del trial).
// La separación en función pura existe para poder testearla; App.tsx solo la llama.
// Ver ADR-2026-08-31-verificacion-celular-supabase.

export interface DatosGateCelular {
  /** Flag de ConfigCat ya resuelto. Fail-open: ante error, pasar false. */
  gateActivo: boolean;
  /** session.user.created_at (ISO). */
  createdAt: string | undefined;
  /** session.user.email. */
  email: string | undefined;
  /**
   * session.user.app_metadata.provider — proveedor de ORIGEN de la cuenta ('email',
   * 'google', …). app_metadata solo lo escribe el server de Auth (no es forjable desde
   * el cliente, a diferencia de user_metadata).
   */
  provider: string | undefined;
  /** session.user.phone_confirmed_at — solo lo escribe Supabase Auth. */
  phoneConfirmedAt: string | null | undefined;
  /** Bypass dev existente (lib/devSkipOnboarding, solo DEV). */
  saltearOnboardingActivo: boolean;
  /** window.location.pathname al momento del chequeo. */
  pathname: string;
}

export function debeVerificarCelular(d: DatosGateCelular): boolean {
  if (!d.gateActivo) return false;
  // Ya está en la pantalla de verificación: redirigir de nuevo sería un loop.
  if (d.pathname.startsWith('/verificar-celular')) return false;
  // El onboarding externo de Tiendanube no se interrumpe a mitad de flujo (mismo
  // criterio que el redirect al wizard en checkUserProfile).
  if (d.pathname.startsWith('/tiendanube')) return false;
  // El checkout de pago directo (/alta-empresa) crea la cuenta en el paso 1 y el
  // pago viene DESPUÉS, en la misma pantalla: interrumpir acá corta un pago en
  // curso. El gate lo alcanza recién en la próxima entrada completa a la app.
  if (d.pathname.startsWith('/alta-empresa')) return false;
  // Cuentas de test del equipo (criterio dev_tester: "prueba" en el mail).
  if (d.email && d.email.includes('prueba')) return false;
  if (d.saltearOnboardingActivo) return false;
  if (d.phoneConfirmedAt) return false;
  // Solo cuentas creadas con email+contraseña (decisión de producto 2026-09-01):
  // Google/OAuth quedan exentas — crear Gmails en masa ya lo encarece Google.
  // Sin provider (dato faltante) también se exime: fail-open.
  if (d.provider !== 'email') return false;
  // Grandfathering: sin created_at no se puede afirmar que sea nueva → fail-open.
  if (!d.createdAt) return false;
  const creada = new Date(d.createdAt).getTime();
  const corte = new Date(PHONE_GATE_CUTOFF).getTime();
  return Number.isFinite(creada) && creada >= corte;
}
